class TopBanner extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback () {
    this.addAttributes();
    this.addEvents();
    this.updateStyles();
  }

  disconnectedCallback () {
    window.removeEventListener('resize', this.updateStyles, false)
    this.removeAttributes();
  }

  addEvents() {
    this.updateStyles = this.updateStyles.bind(this);
    window.addEventListener('resize', this.updateStyles)
  }

  addAttributes() {
    document.body.setAttribute('data-top-banner', '');
    if (this.dataset.position === 'header') {
      document.body.setAttribute('data-top-banner-position', 'header');
    }
  }

  removeAttributes() {
    document.body.removeAttribute('data-top-banner');
    document.body.removeAttribute('data-top-banner-position');
  }

  updateStyles() {
    const banner = this;
    const bannerHeight = banner.offsetHeight;

    if (bannerHeight > 0) {
      document.documentElement.style.setProperty('--top-banner-height', `${bannerHeight}px`);
    }
  }
}

customElements.define('top-banner', TopBanner);

class TopBannerSlider extends HTMLElement {
  constructor() {
    super();

    this.config = {
      autorotate: this.dataset.autorotate === 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000,
    };

    this.slider = this.querySelector('.top-banner-slider');
    this.slides = Array.from(this.slider.children);

    this.init();

    if (this.config.autorotate && this.slides.length > 1) {
       this.startAutoRotate();
    }

    this.addEvents();
  }

  addEvents() {
    this.onResize = this.onResize.bind(this);
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    clearInterval(this.interval);
  }

  onResize() {
    this.reset();
    this.init();
  }

  init() {
    this.currentIndex = 0;
    this.slides[this.currentIndex].classList.add('active');
    this.classList.add('initialized');
  }

  reset() {
    document.documentElement.style.removeProperty('--top-banner-height');
    this.classList.remove('initialized');
    this.slides.forEach(slide => slide.classList.remove('active'));
    document.querySelector('top-banner').updateStyles();
  }

  startAutoRotate() {
    this.interval = setInterval(() => {
      this.nextSlide();
    }, this.config.autorotateSpeed);
  }

  nextSlide() {
    this.slides[this.currentIndex].classList.remove('active');
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.slides[this.currentIndex].classList.add('active');
  }
}

customElements.define('top-banner-slider', TopBannerSlider);
